/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ObservableModel } from '@typescript-kit/core';

export interface TimeClockRegisterViewData {
  token?: string;
}

export class TimeClockRegisterViewFieldKey {
  static readonly TOKEN = 'token';
}

export class TimeClockRegisterViewModel extends ObservableModel {
  static readonly KEYS = Object.keys(TimeClockRegisterViewFieldKey).map((key) => TimeClockRegisterViewFieldKey[key]);

  constructor(data?: TimeClockRegisterViewData) {
    super(data, TimeClockRegisterViewModel.KEYS);
  }

  get token(): string {
    return this.get(TimeClockRegisterViewFieldKey.TOKEN);
  }

  set token(value: string) {
    this.set(TimeClockRegisterViewFieldKey.TOKEN, value);
  }

}
